var HariLiburNasional = {
    "1 Januari": "Tahun Baru Masehi",
    "1 Juni": "Hari kelahiran Pancasila",
    "1 Mei": "Hari Buruh",
    "17 Agustus": "Hari Kemerdekaan",
    "25 Desember": "Hari Raya Natal",
}

var HariLiburIslam = {
    "1 Sawal": "Hari Raya Idul Fitri",
    "1 Sura": "Tahun Baru Hijriyah",
    "2 Sawal": "Hari Raya Idul Fitri",
    "10 Besar": "Hari Raya Idul Adha",
    "12 Mulud": "Maulid Nabi Muhammad",
    "27 Rejeb": "Isra Mi'raj",
}

var ChineseNewYear = ['2000-02-05', '2001-01-24', '2002-02-12', '2003-02-01', '2004-01-22', '2005-02-09', '2006-01-29', '2007-02-18', '2008-02-07', '2009-01-26', '2010-02-14', '2011-02-03', '2012-01-23', '2013-02-10', '2014-01-31', '2015-02-19', '2016-02-08', '2017-01-28', '2018-02-16', '2019-02-05', '2020-01-25', '2021-02-12', '2022-02-01', '2023-01-22', '2024-02-10', '2025-01-29', '2026-02-17', '2027-02-06', '2028-01-26', '2029-02-13', '2030-02-03', '2031-01-23', '2032-02-11', '2033-01-31', '2034-02-19', '2035-02-08']

var HariNyepi = ['2009-03-26', '2010-03-16', '2011-03-05', '2012-03-23', '2013-03-12', '2014-03-31', '2015-03-21', '2016-03-09', '2017-03-28', '2018-03-17', '2019-03-07', '2020-03-25', '2021-03-14', '2022-03-03', '2023-03-22', '2024-03-11', '2025-03-29', '2026-03-19', '2027-03-08', '2028-03-26', '2029-03-15', '2030-03-05', '2031-03-24', '2032-03-12', '2033-03-31', '2034-03-20']

var JumatAgung = ['2017-04-14', '2018-03-30', '2019-04-19', '2020-04-10', '2021-04-02', '2022-04-15', '2023-04-07', '2024-03-29', '2025-04-18', '2026-04-03', '2027-03-26', '2028-04-14', '2029-03-30', '2030-04-19', '2031-04-11', '2032-03-26', '2033-04-15', '2034-04-07', '2035-03-23']

var KenaikanIsa = ['2018-05-10', '2019-05-30', '2020-05-21', '2021-05-13', '2022-05-26', '2023-05-18', '2024-05-09', '2025-05-29', '2026-05-14', '2027-05-06', '2028-05-25', '2029-05-10', '2030-05-30', '2031-05-22', '2032-05-06', '2033-05-26', '2034-05-18', '2035-05-03']

var Waisak = ['2020-05-07', '2021-05-26', '2022-05-16', '2023-05-06', '2024-05-23', '2025-05-12', '2026-05-31', '2027-05-20', '2028-05-09', '2029-05-28', '2030-05-17', '2031-05-07', '2032-05-25', '2033-05-14', '2034-06-02', '2035-05-22']

export {HariLiburNasional, HariLiburIslam, ChineseNewYear, HariNyepi, JumatAgung, KenaikanIsa, Waisak}
